function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2015 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * @polymerMixin
 */
export var ComboBoxItemMixin = function ComboBoxItemMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(ComboBoxItemMixinClass, _superClass);

    var _super = _createSuper(ComboBoxItemMixinClass);

    function ComboBoxItemMixinClass() {
      _classCallCheck(this, ComboBoxItemMixinClass);

      return _super.apply(this, arguments);
    }

    _createClass(ComboBoxItemMixinClass, [{
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'hidden' && newValue !== null) {
          // The element is being hidden (by virtualizer). Mark one of the __rendererOrItemChanged
          // dependencies as undefined to make sure it's called when the element is shown again
          // and assigned properties with possibly identical values as before hiding.
          this.index = undefined;
        } else {
          _get(_getPrototypeOf(ComboBoxItemMixinClass.prototype), "attributeChangedCallback", this).call(this, name, oldValue, newValue);
        }
      }
      /** @protected */

    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(ComboBoxItemMixinClass.prototype), "connectedCallback", this).call(this);

        this._owner = this.parentNode.owner;

        var hostDir = this._owner.getAttribute('dir');

        if (hostDir) {
          this.setAttribute('dir', hostDir);
        }
      }
      /**
       * Requests an update for the content of the item.
       * While performing the update, it invokes the renderer passed in the `renderer` property.
       *
       * It is not guaranteed that the update happens immediately (synchronously) after it is requested.
       */

    }, {
      key: "requestContentUpdate",
      value: function requestContentUpdate() {
        if (!this.renderer) {
          return;
        }

        var model = {
          index: this.index,
          item: this.item,
          focused: this.focused,
          selected: this.selected
        };
        this.renderer(this, this._owner, model);
      }
      /** @private */

    }, {
      key: "__rendererOrItemChanged",
      value: function __rendererOrItemChanged(renderer, index, item) {
        if (item === undefined || index === undefined) {
          return;
        }

        if (this._oldRenderer !== renderer) {
          this.innerHTML = ''; // Whenever a Lit-based renderer is used, it assigns a Lit part to the node it was rendered into.
          // When clearing the rendered content, this part needs to be manually disposed of.
          // Otherwise, using a Lit-based renderer on the same node will throw an exception or render nothing afterward.

          delete this._$litPart$;
        }

        if (renderer) {
          this._oldRenderer = renderer;
          this.requestContentUpdate();
        }
      }
      /** @private */

    }, {
      key: "__updateLabel",
      value: function __updateLabel(label, renderer) {
        if (renderer) {
          return;
        }

        this.textContent = label;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * The index of the item.
           */
          index: {
            type: Number
          },

          /**
           * The item to render.
           */
          item: {
            type: Object
          },

          /**
           * The text to render in the item.
           */
          label: {
            type: String
          },

          /**
           * True when item is selected.
           */
          selected: {
            type: Boolean,
            value: false,
            reflectToAttribute: true
          },

          /**
           * True when item is focused.
           */
          focused: {
            type: Boolean,
            value: false,
            reflectToAttribute: true
          },

          /**
           * Custom function for rendering the item content.
           */
          renderer: {
            type: Function
          }
        };
      }
    }, {
      key: "observers",
      get: function get() {
        return ['__rendererOrItemChanged(renderer, index, item.*, selected, focused)', '__updateLabel(label, renderer)'];
      }
    }, {
      key: "observedAttributes",
      get: function get() {
        return [].concat(_toConsumableArray(_get(_getPrototypeOf(ComboBoxItemMixinClass), "observedAttributes", this)), ['hidden']);
      }
    }]);

    return ComboBoxItemMixinClass;
  }(superClass);
};